import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import AppContainer from "@/components/layout/AppContainer.vue";
import { useThemeStore } from "@/stores/theme";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

useThemeStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppContainer))
}
}

})